<div class="bg-white">
    <h2 class="settings-header px-4 py-3 mb-2 mb-md-5">
        {{'digests_settings' | translate}}
        <small>- {{'digests_settings_desc' | translate}}<a href="http://help.teammood.com/en/articles/5429721-the-periodic-digest" target="_blank" class="help" title="{{'digests_help_link' | translate}}"><i class="far fa-question-circle"></i></a></small>
    </h2>
    
    <div class="settings-sub-header w-100 p-2">
        <div class="col-md-10 mx-auto d-md-flex justify-content-between">
            <div class="pe-0 pe-md-5">
                <h4>{{ 'digests_subtitle_settings' | translate}}</h4>
                <h4>
                    <small>{{'digests_subtitle_settings_desc_1' | translate}} <a routerLink="/setup/integrations" target="_blank">{{'digests_subtitle_settings_desc_2' | translate}}</a>
                    </small>
                </h4>
            </div>
            <div>
                <button type="button" class="btn btn-primary" (click)="addDigest()"> {{'digests_setting.new' | translate}}</button>
            </div>
        </div>
    </div>
    
    @if(digests) {
        @if(digests.length === 0){
            <div class="row bg-grey pt-3">
                <div class="col-md-10 mx-auto">
                    <div class="view_example_title">
                        <p class="py-1">{{'digests_placeholder_desc_1' | translate}}</p>
                        <p class="py-1">{{'digests_placeholder_desc_2' | translate}}</p>
                    </div>
                    @if(locale === 'fr'){
                        <img src="/assets/images/view_examples/report_example_fr.png" alt="exemple de résumé d'activités" class="view_example_img">
                    }@else{
                        <img src="/assets/images/view_examples/report_example_en.png" alt="activity digest example" class="view_example_img">
                    }
                </div>
            </div>
        }
        @else if(frequencies && daysOfWeek){
            <div class="row bg-grey table-responsive pt-4 p-2">
                <div class="col-md-10 mx-auto">
                    <table class="table table-hover">
                        <thead class="digests_table_header">
                            <tr>
                                <th scope="col">{{'digests_setting.filter' | translate}}</th>
                                <th scope="col">{{'digests_setting.frequency' | translate}}</th>
                                <th scope="col">{{'digests_setting.frequency.day' | translate}}</th>
                                <th scope="col" class="text-center">{{'digests_setting.actions' | translate}}</th>
                                <th scope="col" class="text-center">{{'digests_setting.status' | translate}}</th>
                                <th scope="col" class="text-center">{{'digests_setting.delete' | translate}}</th>
                            </tr>
                        </thead>
            
                        <tbody>
                            @for(digest of digests; track digest.id) {
                                <tr class="align-baseline" [ngClass]="{'disabledDigest': !digest.enabled}">
                                    <td>{{digest.filterTitle}}</td>
                                    @switch(digest.frequency) {
                                        @case('weekly'){
                                            <td>
                                                <span>{{frequencies[0]['label']}}</span>
                                            </td>
                                            <td>
                                                <span>{{daysOfWeek[digest.dayOfDigest - 1].label}}</span>
                                            </td>
                                        }
                                        @case('monthly'){
                                            <td>
                                                <span>{{frequencies[1]['label']}}</span>
                                            </td>
                                            <td>
                                                <span>{{digest.dayOfDigest}}</span>
                                            </td>
                                        }
                                    }
                                    <td class="text-center">
                                        <button type="button" class="btn btn-secondary mx-1" 
                                                (click)="openUpdateModale(digest)" 
                                                title="{{'digests_setting.actions.update_desc' | translate}}"><i class="far fa-pen"></i>
                                        </button>
                
                                        <button type="button" class="btn btn-secondary mx-1" 
                                                (click)="duplicate(digest)" 
                                                title="{{'digests_setting.actions.duplicate_desc' | translate}}"><i class="far fa-copy"></i>
                                        </button>
                                        <button type="button" class="btn btn-secondary mx-1" 
                                                (click)="test(digest.id)" 
                                                title="{{'digests_setting.actions.test_desc' | translate}}"><i class="far fa-play"></i>
                                        </button>
                                    </td>
                                    <td class="text-center">
                                        <mat-slide-toggle [checked]="digest.enabled" 
                                                          (change)="toggle_status(digest)"></mat-slide-toggle>
                                    </td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-danger" 
                                                (click)="remove(digest.id)" 
                                                title="{{'digests_setting.delete_desc' | translate}}"><i class="far fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        }    
    }
</div>


